package de.connect2x.timmy.customcomponents
import androidx.compose.foundation.layout.*
import androidx.compose.runtime.*
import androidx.compose.ui.graphics.Color
import de.connect2x.trixnity.messenger.compose.view.settings.AppearanceSettingsColorView


class DisabledAccentColorViewWcImpl : AppearanceSettingsColorView {
    @Composable
    override fun ColumnScope.create(text: String, defaultColor: Color, color: Color, set: (Color) -> Unit) {
        // Component with accent color slider should not be displayed, therefore an empty return
        // Decision against overwriting on a higher-level component due to updating issues
    }
}


